import { DateTimeFormatOptions } from "../../Models/Classes";

export const GetDateTimeFormatOptions = (options: DateTimeFormatOptions): Intl.DateTimeFormatOptions => {
    if (options.twoDigits) return { year: "2-digit", month: "2-digit", day: "2-digit" };
    if (options.monthLabel) return options.noYear ? { month: "long", day: "2-digit" } : { year: "2-digit", month: "long", day: "2-digit" };
    if (options.withTime && options.noYear) return { month: "2-digit", day: "2-digit", hour: "numeric", minute: "numeric" };
    if (options.noYear) return { month: "2-digit", day: "2-digit" };
    if (options.withTime) return { year: "numeric", month: "2-digit", day: "2-digit", hour: "numeric", minute: "numeric" };
    if (options.onlyTime) return { hour: "numeric", minute: "numeric" };
    return { year: "numeric", month: "2-digit", day: "2-digit" };
}
